import { maxLengthParser, onlyNumbersParser } from '../common/parse';

export const getSecurityCodeParser = (length: number) => (value: string) =>
  maxLengthParser(onlyNumbersParser(value), length);
